import { isAxiosError } from "axios";

export const SERVER_REDIRECT_STATUS = 409;

export function responseStatus(error: unknown): number | null {
    return isAxiosError(error) ? (error.response?.status ?? null) : null;
}

export function serverRedirect(error: unknown): string | null {
    if (
        !isAxiosError(error) ||
        error.response?.status !== SERVER_REDIRECT_STATUS
    ) {
        return null;
    }

    const redirect: unknown = error.response.data?.redirect;

    return typeof redirect === "string" ? redirect : null;
}

export function validationErrors(
    error: unknown,
): Partial<Record<string, string>> | null {
    if (!isAxiosError(error) || error.response?.status !== 422) {
        return null;
    }

    const errors: unknown = error.response.data?.errors;
    if (typeof errors !== "object" || errors === null) {
        return {};
    }

    return Object.fromEntries(
        Object.entries(errors).map(([field, messages]) => [
            field,
            Array.isArray(messages) ? String(messages[0]) : String(messages),
        ]),
    );
}

export function shouldShowErrorPage(error: unknown): boolean {
    const status = responseStatus(error);

    return status === 403 || status === 404 || (status ?? 0) >= 500;
}
